var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { memo } from "react";
var SvgTimes = function SvgTimes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.707 12.707a1 1 0 0 1-1.414-1.414zM8 8l.707-.707a1 1 0 0 1 0 1.414zM3.293 4.707a1 1 0 0 1 1.414-1.414zm0 6.586 4-4 1.414 1.414-4 4zm4-2.586-4-4 1.414-1.414 4 4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.293 12.707a1 1 0 0 0 1.414-1.414zM8 8l-.707-.707a1 1 0 0 0 0 1.414zm4.707-3.293a1 1 0 0 0-1.414-1.414zm0 6.586-4-4-1.414 1.414 4 4zm-4-2.586 4-4-1.414-1.414-4 4z"
  })));
};
var Memo = /*#__PURE__*/memo(SvgTimes);
export default Memo;